const getListSpecificSearchFilter = (searchFilters, listName) => {
  const searchFilterMatch = searchFilters.find(({
    settings: {
      listComponentName
    }
  }) => listComponentName === listName);
  const hasListSpecificFilters = !!searchFilterMatch;
  const searchFilterToUse = searchFilterMatch || searchFilters[0] || {};
  return [searchFilterToUse, hasListSpecificFilters];
};
export default getListSpecificSearchFilter;
//# sourceMappingURL=get-list-specific-search-filter.js.map